import * as types from '../../constants/action_types'
import { EMPTY_ORDER_ITEM } from '../../constants/supplier_tracker/orders'

export const initialState = {
  savePurchaseOrder: {
    isLoading: false,
    completed: false
  },

  deletePurchaseOrder: {
    isLoading: false,
    completed: false
  },

  ordersBySupplierGroupMap: {},

  tableMetadata: {},

  purchaseOrder: {
    issued_at: '',
    supplier_name: '',
    ship_to: '',
    order_number: '',
    supplier_address: '',
    message: '',
    agreements: '',
    total_price: 0,
    purchase_order_items: [EMPTY_ORDER_ITEM]
  }
}

function supplierTrackerOrdersReducer(state = initialState, action) {
  switch (action.type) {
    case types.PENDING_PURCHASE_ORDERS_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: true,
          completed: false
        }
      }
    case types.COMPLETED_PURCHASE_ORDERS_ACTION:
      return {
        ...state,
        [action.payload]: {
          isLoading: false,
          completed: true
        }
      }
    case types.RESET_PURCHASE_ORDERS_ACTION:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          isLoading: false,
          completed: false
        }
      }
    case types.SET_PURCHASE_ORDER:
      return {
        ...state,
        purchaseOrder: action.payload
      }
    case types.SET_PURCHASE_ORDERS:
      return {
        ...state,
        ordersBySupplierGroupMap: {
          ...state.ordersBySupplierGroupMap,
          ...action.payload
        }
      }
    case types.SET_PURCHASE_ORDER_TABLE_METADATA: {
      return {
        ...state,
        tableMetadata: {
          ...state.tableMetadata,
          ...action.payload
        }
      }
    }
    default:
      return state
  }
}

export default supplierTrackerOrdersReducer
